// for user registration
export const REGISTER_USER = "register_user";
export const REGISTER_USER_SUCCESS = "register_user_success";
export const REGISTER_USER_FAILURE = "register_user_failure";
